import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb } from '../Breadcrumb';
import { Heading } from '../Heading';
import styles from '@dtsl/css-page-header/dist/index.module.css';
function PageHeader(props) {
  const {
    heading = '',
    breadcrumbs = null,
    children,
    actions = () => {}
  } = props;
  const headerHTML = /*#__PURE__*/React.createElement("div", {
    className: styles['sib-page-heading']
  }, /*#__PURE__*/React.createElement(Heading, {
    className: styles['sib-page-heading__title'],
    level: 1
  }, heading), /*#__PURE__*/React.createElement("div", {
    className: styles['sib-page-heading__actions']
  }, actions()));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles['sib-page-header']
  }, breadcrumbs ? /*#__PURE__*/React.createElement(Breadcrumb, {
    breadcrumbs: breadcrumbs
  }) : '', headerHTML), /*#__PURE__*/React.createElement("div", {
    className: styles['sib-page-content']
  }, children));
}
PageHeader.propTypes = {
  heading: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
    target: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string
  })),
  actions: PropTypes.func,
  children: PropTypes.node
};
export default PageHeader;